import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {getPowerSourceLocationsData, IPowerSource, IPowerSourceLocation} from "../../../../data/data";
import MapLocation from "./MapLocation";
import {startDragging, stopDragging} from "../../../../store/actions/interaction";
import {setMapOffset} from "../../../../store/actions/mapOffset";
import {setMapBounds} from '../../../../store/actions/mapBounds';
import {getMapWweatherState} from '../../../../store/reducers/map/mapState';

interface Props
{
    weather_state: string;
    startDragging: () => void;
    stopDragging: () => void;
    setMapBounds: (width: number, height: number) => void;
    setMapOffset: (ox: number, oy: number) => void;
}

interface State
{
    x: number;
    y: number;
}

import './GameplayMap.scss';

class GameplayMap extends React.Component<Props, State>
{
    px: number;
    py: number;
    width: number;
    height: number;

    constructor(public props: Props, public state: State)
    {
        super(props);

        this.state = { x: -1730, y: -2890 };
    }


    componentDidMount()
    {

    }


    /**
     * when the user presses the mouse down, start to drag
     * @param {React.MouseEvent<HTMLDivElement>} mouse_event
     */
    onMouseDown = (mouse_event: React.MouseEvent<HTMLDivElement>) =>
    {
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);

        this.px = mouse_event.pageX;
        this.py = mouse_event.pageY;

        this.props.startDragging();
    };


    /**
     * when the user moves the mouse, move the map
     * @param {MouseEvent} mouse_event
     */
    onMouseMove = (mouse_event: MouseEvent) =>
    {
        const {setMapOffset} = this.props;

        const dx: number = this.px - mouse_event.pageX;
        const dy: number = this.py - mouse_event.pageY;

        const {x:nx, y:ny} = this.state;

        const x: number = _.clamp(nx - dx, window.innerWidth - this.width, 0);
        const y: number = _.clamp(ny - dy, window.innerHeight - this.height, 0);

        this.px = mouse_event.pageX;
        this.py = mouse_event.pageY;

        this.setState({x, y});

        //  save the offset to the store

        setMapOffset(x, y);
    };


    /**
     * when the user releases the mouse, stop dragging
     * @param {MouseEvent} mouse_event
     */
    onMouseUp = (mouse_event: MouseEvent) =>
    {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);

        this.props.stopDragging();
    };


    /**
     * create map location elements
     */
    getMapLocations = () =>
    {
        //  get the list of locations from the data

        const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();

        return _.map(locations, (location: IPowerSourceLocation, i: number) =>
        {
            return <MapLocation
                        {...location}
                        location_id={i}
                        key={i}/>
        })
    };


    /**
     * measure the map element
     * @param {HTMLDivElement} el
     */
    measureMap = (el: HTMLDivElement) =>
    {
        if (! el) return;

        const bounds: ClientRect = el.getBoundingClientRect();

        this.width = bounds.width;
        this.height = bounds.height;

        const {setMapBounds} = this.props;

        setMapBounds(this.width, this.height);
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {weather_state} = this.props;
        const {x, y} = this.state;

        return <div styleName={weather_state}
                    style={{ top: y, left: x }}
                    onMouseDown={this.onMouseDown}
                    ref={this.measureMap}>

            {this.getMapLocations()}

        </div>
    }
}


/**
 * GameplayMap the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        weather_state: getMapWweatherState(state),
    }
};


/**
 * GameplayMap dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        startDragging: () => dispatch(startDragging()),
        stopDragging: () => dispatch(stopDragging()),
        setMapBounds: (width: number, height: number) => dispatch(setMapBounds(width, height)),
        setMapOffset: (ox: number, oy: number) => dispatch(setMapOffset(ox, oy)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GameplayMap);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/map/GameplayMap.tsx